import axios from "axios";

export const getCurrent = () => {
    return axios.get("/userManagement/getCurrent");
}

export const getAll = () => {
    return axios.get("/userManagement/getAll");
}
